<template>
  <div>
    <v-fab-transition v-if="isModification">
      <v-btn v-hotkey="'ctrl+s'" color="green" @click="save" icon size="large" class="fab-fixed-bottom-right">
        <v-icon size="large">mdi-content-save-outline</v-icon>
      </v-btn>
    </v-fab-transition>
    <v-form ref="sectionFlow" v-model="valid">
      <v-container>
        <v-row>
          <v-col>
            <v-alert v-if="errorMessage" density="compact" variant="tonal" border="start" type="error">
              {{ errorMessage }}
            </v-alert>
            <v-alert v-if="isModification" density="compact" variant="tonal" border="start" type="warning">
              Modifications non sauvegardées. Sauvegardez (CTRL+S) avant de changer de section ou d'onglet.
            </v-alert>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" class="d-flex flex-column ga-3">
            <p v-if="extrapolation.gauge_id">gauge id : {{ extrapolation.gauge_id }}</p>
            <p v-if="!extrapolation.gauge_id">
              gauge id : <span class="text-warning">Aucune extrapolation pour cette section</span>
            </p>
            <p>type : {{ extrapolation.type }}</p>
            <v-combobox
              v-model="extrapolation.gauge_station_name"
              :items="processedGauges"
              item-title="displayText"
              item-value="name"
              label="Station"
              @update:model-value="updateExtrapolationGaugeInfo($event)"
              required
            ></v-combobox>
            <v-number-input
              label="Extrapolation montante"
              :model-value="toNumberOrNull(extrapolation.weighting_up)"
              :min="0"
              :precision="null"
              :step="0.1"
              required
              @update:model-value="extrapolation.weighting_up = $event"
            ></v-number-input>
            <v-number-input
              label="Extrapolation descendante"
              :model-value="toNumberOrNull(extrapolation.weighting_down)"
              :min="0"
              :precision="null"
              :step="0.1"
              required
              @update:model-value="extrapolation.weighting_down = $event"
            ></v-number-input>
          </v-col>
          <v-col cols="6"> </v-col>
        </v-row>
      </v-container>
    </v-form>
  </div>
</template>

<script>
  import SectionsService from "@/store/modules/sections";
  import { notify } from "@/services/Notification.service";
  import { toNumberOrNull } from "@/utils/numbers";
  export default {
    props: {
      section: {
        type: Object,
        default: function () {
          return {};
        },
      },
      reloadData: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        isModification: false,
        errorMessage: "",
        valid: true,
        extrapolation: {},
      };
    },
    async created() {
      await this.getGauges();
      this.getExtrapolation();
    },
    methods: {
      toNumberOrNull,
      async getExtrapolation() {
        const extrapolations = await SectionsService.actions.getExtrapolationBySectionId(this.section.id);
        if (extrapolations) {
          this.extrapolation = extrapolations[0];
        } else {
          this.extrapolation = {
            type: "CEHQ",
          };
        }
      },
      async getGauges() {
        await this.$store.dispatch("bindGauges");
      },
      updateExtrapolationGaugeInfo(event) {
        // Typing in the combobox also emits plain strings; only a picked gauge updates the extrapolation
        if (!event || typeof event !== "object") return;
        this.extrapolation.gauge_station_name = event.name;
        this.extrapolation.gauge_id = event.id;
        this.extrapolation.type = event.type;
      },
      async save() {
        if (this.valid) {
          const gaugeExist = this.lookIfGaugeExist();
          console.log("gaugeExist is " + gaugeExist); // TODO add river (create alias)

          SectionsService.actions
            .setExtrapolation(this.section.id, this.extrapolation)
            .then(() => {
              this.isModification = false;
              notify("La section a été sauvegardée avec succès.");
            })
            .catch((error) => {
              console.log(error);
              this.errorMessage =
                "Une erreur s'est produite lors de la sauvegarde de l'extrapolation', vérifiez les résultats et recommencez.";
            });
        } else {
          this.errorMessage = "Certains champs obligatoires ne répondent pas aux critères attendus, veuillez vérifier.";
        }
      },
      lookIfGaugeExist() {
        const gauges = this.$store.getters.gauges;
        var exist = false;
        gauges.forEach((gauge) => {
          if (gauge.name.toLowerCase() === this.extrapolation.gauge_station_name.toLowerCase()) {
            exist = true;
          }
        });
        return exist;
      },
    },
    computed: {
      gauges() {
        return this.$store.getters.gauges;
      },
      processedGauges() {
        return this.gauges.map((gauge) => ({
          ...gauge,
          displayText: gauge.description ? `${gauge.name} - ${gauge.description}` : gauge.name,
        }));
      },
    },
    watch: {
      reloadData() {
        if (this.reloadData) {
          this.getExtrapolation();
          this.$emit("update", false);
        }
      },
      extrapolation: {
        deep: true,
        handler(oldValue, newValue) {
          this.errorMessage = "";
          if (oldValue.id !== newValue.id) {
            this.isModification = false;
          } else {
            this.isModification = true;
          }
        },
      },
    },
  };
</script>

<style lang="scss" scoped></style>
